import rightImg from '../../assets/images/img2.jpg'

import styles from './RightSide.module.css'

const RightSide = () => {
  return (
    <div className={styles.container}>
      <img src={rightImg} alt="Imagine dreapta" />
    </div>
  )
}
export default RightSide
